/// <reference path='../scenes/SeancesScene.ts'/>
/// <reference path='../../scaffolding/Main.ts'/>
/// <reference path='../../scaffolding/EventBus.ts'/>
/// <reference path='../../scaffolding/Utils.ts'/>
/// <reference path='../ProgressCircle.ts'/>
/// <reference path='../title/TitleGenerator.ts'/>
/// <reference path='../shaders/RGBGlitchShader.ts'/>
/// <reference path='../shaders/MPEGArtifactShader.ts'/>
/// <reference path='../assets/GridImages.ts'/>
/// <reference path='../installation/InstallationTitleSequence.ts'/>
/// <reference path='../installation/PhotoCard.ts'/>
/// <reference path='../installation/VideoCard.ts'/>
/// <reference path='../installation/CardLayer.ts'/>
/// <reference path='../installation/InstallationGenreSequence.ts'/>
/// <reference path='../installation/InstallationVideoBackground.ts'/>

class MultiTouchInterfaceScene extends SeancesScene {

    public static AUTO_CYCLE:boolean = true;
    public static ROTATE:boolean = true;
    public static SWAP_IMAGES:boolean = true;
    public static PROXIMITY_TRIGGER:boolean = true;
    public static FILL_RATE:number = 0.6;
    private static EMITTER_PARTICLES:number = 200;
    public static VIDEO_RATE:number = 0.5;
    public static TOUCH_END:string = "interfacetouchend";
    public static TOUCH_MOVE:string = "interfacetouchmove";
    public static RESOLVING:boolean = false;
    private static MAX_TOUCHES:number = 10;

    private titleSequence:InstallationTitleSequence;
    private glitchPass:ShaderPass;
    private textureLoader:THREE.TextureLoader;

    private intensityTimeout:number = -1;

    private texAtlas:TextureAtlas;
    private intensityTween:TweenMax;
    private seaRenderer:LineTextureRenderer;
    private backgroundDims:CameraView;
    private videoBackground:InstallationVideoBackground;

    private cards:PhotoCard[] = [];
    private cardPool:PhotoCard[] = [];
    private cardLayers:CardLayer[] = [];

    private cardZPos = -210;
    private frustum:THREE.Frustum;
    private touches:Touch[] = [];
    private touchPositions:THREE.Vector3[] = [];
    private touchedCards:PhotoCard[] = [];

    private particleGroup:SPE.Group;
    private particleEmitter:{[key:string]:SPE.Emitter} = {};
    private raycaster:THREE.Raycaster;
    private activeCards:number = 0;
    private genreSequence:InstallationGenreSequence;
    private cardPositions:CardPos[] = [];

    private playOverlay:PlayOverlay;
    public cardImagePool:string[] = ['GRID_IMAGE00001.png','GRID_IMAGE00002.png','GRID_IMAGE00003.png','GRID_IMAGE00004.png','GRID_IMAGE00005.png','GRID_IMAGE00006.png','GRID_IMAGE00007.png','GRID_IMAGE00008.png','GRID_IMAGE00009.png','GRID_IMAGE00010.png','GRID_IMAGE00011.png','GRID_IMAGE00012.png','GRID_IMAGE00013.png','GRID_IMAGE00014.png','GRID_IMAGE00015.png','GRID_IMAGE00016.png','GRID_IMAGE00017.png','GRID_IMAGE00018.png','GRID_IMAGE00019.png','GRID_IMAGE00020.png','GRID_IMAGE00021.png','GRID_IMAGE00022.png','GRID_IMAGE00023.png','GRID_IMAGE00024.png','GRID_IMAGE00025.png','GRID_IMAGE00026.png','GRID_IMAGE00027.png','GRID_IMAGE00028.png','GRID_IMAGE00029.png','GRID_IMAGE00030.png','GRID_IMAGE00031.png','GRID_IMAGE00032.png','GRID_IMAGE00033.png','GRID_IMAGE00034.png','GRID_IMAGE00035.png','GRID_IMAGE00036.png','GRID_IMAGE00037.png','GRID_IMAGE00038.png','GRID_IMAGE00039.png','GRID_IMAGE00040.png','GRID_IMAGE00041.png','GRID_IMAGE00042.png','GRID_IMAGE00043.png','GRID_IMAGE00044.png','GRID_IMAGE00045.png','GRID_IMAGE00046.png','GRID_IMAGE00047.png','GRID_IMAGE00048.png','GRID_IMAGE00049.png','GRID_IMAGE00050.png','GRID_IMAGE00051.png','GRID_IMAGE00052.png','GRID_IMAGE00053.png','GRID_IMAGE00054.png','GRID_IMAGE00055.png','GRID_IMAGE00056.png','GRID_IMAGE00057.png','GRID_IMAGE00058.png','GRID_IMAGE00059.png','GRID_IMAGE00060.png','GRID_IMAGE00061.png','GRID_IMAGE00062.png','GRID_IMAGE00063.png','GRID_IMAGE00064.png','GRID_IMAGE00065.png','GRID_IMAGE00066.png','GRID_IMAGE00067.png','GRID_IMAGE00068.png','GRID_IMAGE00069.png','GRID_IMAGE00070.png','GRID_IMAGE00071.png','GRID_IMAGE00072.png','GRID_IMAGE00073.png','GRID_IMAGE00074.png','GRID_IMAGE00075.png','GRID_IMAGE00076.png','GRID_IMAGE00077.png','GRID_IMAGE00078.png','GRID_IMAGE00079.png','GRID_IMAGE00080.png','GRID_IMAGE00081.png','GRID_IMAGE00082.png','GRID_IMAGE00083.png','GRID_IMAGE00084.png','GRID_IMAGE00085.png','GRID_IMAGE00086.png','GRID_IMAGE00087.png','GRID_IMAGE00088.png','GRID_IMAGE00089.png','GRID_IMAGE00090.png','GRID_IMAGE00091.png','GRID_IMAGE00092.png','GRID_IMAGE00093.png','GRID_IMAGE00094.png','GRID_IMAGE00095.png','GRID_IMAGE00096.png','GRID_IMAGE00097.png','GRID_IMAGE00098.png','GRID_IMAGE00099.png','GRID_IMAGE00100.png','GRID_IMAGE00101.png','GRID_IMAGE00102.png','GRID_IMAGE00103.png','GRID_IMAGE00104.png','GRID_IMAGE00105.png','GRID_IMAGE00106.png','GRID_IMAGE00107.png','GRID_IMAGE00108.png','GRID_IMAGE00109.png','GRID_IMAGE00110.png','GRID_IMAGE00111.png','GRID_IMAGE00112.png','GRID_IMAGE00113.png','GRID_IMAGE00114.png','GRID_IMAGE00115.png','GRID_IMAGE00116.png','GRID_IMAGE00117.png','GRID_IMAGE00118.png','GRID_IMAGE00119.png','GRID_IMAGE00120.png','GRID_IMAGE00121.png','GRID_IMAGE00122.png','GRID_IMAGE00123.png','GRID_IMAGE00124.png','GRID_IMAGE00125.png','GRID_IMAGE00126.png','GRID_IMAGE00127.png','GRID_IMAGE00128.png','GRID_IMAGE00129.png','GRID_IMAGE00130.png','GRID_IMAGE00131.png','GRID_IMAGE00132.png','GRID_IMAGE00133.png','GRID_IMAGE00134.png','GRID_IMAGE00135.png','GRID_IMAGE00136.png','GRID_IMAGE00137.png','GRID_IMAGE00138.png','GRID_IMAGE00139.png','GRID_IMAGE00140.png','GRID_IMAGE00141.png','GRID_IMAGE00142.png','GRID_IMAGE00143.png','GRID_IMAGE00144.png','GRID_IMAGE00145.png','GRID_IMAGE00146.png','GRID_IMAGE00147.png','GRID_IMAGE00148.png','GRID_IMAGE00149.png','GRID_IMAGE00150.png','GRID_IMAGE00151.png','GRID_IMAGE00152.png','GRID_IMAGE00153.png','GRID_IMAGE00154.png','GRID_IMAGE00155.png','GRID_IMAGE00156.png','GRID_IMAGE00157.png','GRID_IMAGE15h22m11s94.png','GRID_IMAGE15h22m19s190.png','GRID_IMAGE15h22m48s163.png','GRID_IMAGE15h23m12s187.png','GRID_IMAGE15h23m17s7.png','GRID_IMAGE15h23m30s112.png','GRID_IMAGE15h23m43s0.png','GRID_IMAGE15h23m48s65.png','GRID_IMAGE15h23m53s113.png','GRID_IMAGE15h23m58s159.png','GRID_IMAGE15h24m03s212.png','GRID_IMAGE15h24m11s7.png','GRID_IMAGE15h24m17s84.png','GRID_IMAGE15h24m27s178.png','GRID_IMAGE15h24m33s239.png','GRID_IMAGE15h24m54s210.png','GRID_IMAGE15h26m08s134.png','GRID_IMAGE15h26m13s232.png','GRID_IMAGE15h26m22s62.png','GRID_IMAGE15h26m28s126.png','GRID_IMAGE15h27m16s0.png','GRID_IMAGE15h27m22s154.png','GRID_IMAGE15h27m28s216.png','GRID_IMAGE15h27m32s8.png','GRID_IMAGE15h27m55s221.png','GRID_IMAGE15h28m08s98.png','GRID_IMAGE15h28m16s164.png','GRID_IMAGE15h28m23s0.png','GRID_IMAGE15h28m29s57.png','GRID_IMAGE15h28m35s109.png','GRID_IMAGE15h29m34s141.png','GRID_IMAGE15h29m38s243.png','GRID_IMAGE15h29m43s26.png','GRID_IMAGE15h30m04s26.png','GRID_IMAGE15h30m18s116.png','GRID_IMAGE15h30m23s170.png','GRID_IMAGE15h30m37s42.png','GRID_IMAGE15h31m11s100.png','GRID_IMAGE15h31m28s50.png','GRID_IMAGE15h31m34s115.png','GRID_IMAGE15h31m41s186.png','GRID_IMAGE15h31m46s230.png','GRID_IMAGE15h31m54s64.png','GRID_IMAGE15h32m17s12.png','GRID_IMAGE15h32m32s184.png','GRID_IMAGE15h32m44s52.png','GRID_IMAGE15h32m50s109.png','GRID_IMAGE15h32m58s189.png','GRID_IMAGE15h33m02s233.png','GRID_IMAGE15h33m16s99.png','GRID_IMAGE15h33m20s156.png','GRID_IMAGE15h33m27s199.png','GRID_IMAGE15h33m39s71.png','GRID_IMAGE15h33m53s222.png','GRID_IMAGE15h33m57s9.png','GRID_IMAGE15h34m03s78.png','GRID_IMAGE15h34m37s140.png','GRID_IMAGE15h34m43s217.png','GRID_IMAGE15h34m52s26.png','GRID_IMAGE15h35m00s130.png','GRID_IMAGE15h36m29s227.png','GRID_IMAGE15h36m45s139.png','GRID_IMAGE15h36m54s235.png','GRID_IMAGE15h37m04s71.png','GRID_IMAGE15h37m22s10.png','GRID_IMAGE15h37m26s52.png','GRID_IMAGE15h37m34s136.png','GRID_IMAGE15h37m56s92.png','GRID_IMAGE15h40m14s190.png','GRID_IMAGE15h40m32s122.png','GRID_IMAGE15h40m37s163.png','GRID_IMAGE15h40m48s30.png','GRID_IMAGE15h40m54s90.png','GRID_IMAGE15h41m01s162.png','GRID_IMAGE15h42m11s56.png','GRID_IMAGE15h42m16s140.png','GRID_IMAGE15h42m21s183.png','GRID_IMAGE15h44m33s222.png','GRID_IMAGE15h44m42s52.png','GRID_IMAGE15h44m49s139.png','GRID_IMAGE15h44m55s192.png','GRID_IMAGE15h45m07s48.png','GRID_IMAGE15h45m26s255.png','GRID_IMAGE15h45m48s212.png','GRID_IMAGE15h45m54s22.png','GRID_IMAGE2016-04-08-15h16m36s73.png','GRID_IMAGE2016-04-08-15h16m40s143.png','GRID_IMAGE2016-04-08-15h16m43s177.png','GRID_IMAGE2016-04-08-15h16m50s242.png','GRID_IMAGE2016-04-08-15h16m53s15.png','GRID_IMAGE2016-04-08-15h16m59s79.png','GRID_IMAGE2016-04-08-15h17m04s133.png','GRID_IMAGE2016-04-08-15h18m46s131.png','GRID_IMAGE2016-04-08-15h18m55s213.png','GRID_IMAGE2016-04-08-15h19m02s37.png','GRID_IMAGE2016-04-08-15h19m04s54.png','GRID_IMAGE2016-04-08-15h19m06s80.png','GRID_IMAGE2016-04-08-15h19m09s103.png','GRID_IMAGE2016-04-08-15h19m11s130.png','GRID_IMAGE2016-04-08-15h19m13s146.png','GRID_IMAGE2016-04-08-15h19m49s241.png','GRID_IMAGE2016-04-08-15h19m51s10.png','GRID_IMAGE2016-04-08-15h19m52s25.png','GRID_IMAGE2016-04-08-15h19m54s40.png','GRID_IMAGE2016-04-08-15h19m56s68.png','GRID_IMAGE2016-04-08-15h19m59s90.png','GRID_IMAGE2016-04-08-15h20m01s114.png','GRID_IMAGE2016-04-08-15h20m04s143.png','GRID_IMAGE2016-04-08-15h20m08s175.png','GRID_IMAGE2016-04-08-15h20m33s181.png','GRID_IMAGE2016-04-08-15h20m35s202.png','GRID_IMAGE2016-04-08-15h20m40s215.png','GRID_IMAGE2016-04-08-15h20m46s51.png','GRID_IMAGE2016-04-08-15h20m54s127.png','GRID_IMAGE2016-04-08-15h21m04s234.png','GRID_IMAGE2016-04-08-15h21m10s29.png'];
    public cardVideoPool:string[] = ["installation_video_1.mp4","installation_video_10.mp4","installation_video_100.mp4","installation_video_101.mp4","installation_video_102.mp4","installation_video_103.mp4","installation_video_104.mp4","installation_video_105.mp4","installation_video_106.mp4","installation_video_107.mp4","installation_video_108.mp4","installation_video_109.mp4","installation_video_11.mp4","installation_video_110.mp4","installation_video_111.mp4","installation_video_112.mp4","installation_video_113.mp4","installation_video_114.mp4","installation_video_115.mp4","installation_video_116.mp4","installation_video_117.mp4","installation_video_118.mp4","installation_video_119.mp4","installation_video_12.mp4","installation_video_120.mp4","installation_video_121.mp4","installation_video_122.mp4","installation_video_123.mp4","installation_video_124.mp4","installation_video_125.mp4","installation_video_126.mp4","installation_video_127.mp4","installation_video_128.mp4","installation_video_129.mp4","installation_video_13.mp4 ","installation_video_130.mp4","installation_video_131.mp4","installation_video_132.mp4","installation_video_133.mp4","installation_video_134.mp4","installation_video_135.mp4","installation_video_136.mp4","installation_video_137.mp4","installation_video_138.mp4","installation_video_139.mp4","installation_video_14.mp4 ","installation_video_140.mp4","installation_video_141.mp4","installation_video_142.mp4","installation_video_143.mp4","installation_video_144.mp4","installation_video_145.mp4","installation_video_146.mp4","installation_video_147.mp4","installation_video_148.mp4","installation_video_149.mp4","installation_video_15.mp4 ","installation_video_150.mp4","installation_video_151.mp4","installation_video_152.mp4","installation_video_153.mp4","installation_video_154.mp4","installation_video_155.mp4","installation_video_156.mp4","installation_video_157.mp4","installation_video_158.mp4","installation_video_159.mp4","installation_video_16.mp4 ","installation_video_160.mp4","installation_video_161.mp4","installation_video_162.mp4","installation_video_163.mp4","installation_video_164.mp4","installation_video_165.mp4","installation_video_166.mp4","installation_video_167.mp4","installation_video_168.mp4","installation_video_169.mp4","installation_video_17.mp4 ","installation_video_170.mp4","installation_video_171.mp4","installation_video_172.mp4","installation_video_173.mp4","installation_video_174.mp4","installation_video_175.mp4","installation_video_176.mp4","installation_video_177.mp4","installation_video_178.mp4","installation_video_179.mp4","installation_video_18.mp4 ","installation_video_180.mp4","installation_video_181.mp4","installation_video_182.mp4","installation_video_183.mp4","installation_video_184.mp4","installation_video_185.mp4","installation_video_186.mp4","installation_video_187.mp4","installation_video_188.mp4","installation_video_19.mp4","installation_video_190.mp4","installation_video_191.mp4","installation_video_192.mp4","installation_video_193.mp4","installation_video_194.mp4","installation_video_195.mp4","installation_video_196.mp4","installation_video_197.mp4","installation_video_198.mp4","installation_video_199.mp4","installation_video_2.mp4","installation_video_20.mp4","installation_video_21.mp4","installation_video_22.mp4","installation_video_23.mp4","installation_video_24.mp4","installation_video_25.mp4","installation_video_26.mp4","installation_video_27.mp4","installation_video_28.mp4","installation_video_29.mp4","installation_video_3.mp4","installation_video_30.mp4","installation_video_31.mp4","installation_video_32.mp4","installation_video_33.mp4","installation_video_34.mp4","installation_video_35.mp4","installation_video_36.mp4","installation_video_37.mp4","installation_video_38.mp4","installation_video_39.mp4","installation_video_4.mp4","installation_video_40.mp4","installation_video_41.mp4","installation_video_42.mp4","installation_video_43.mp4","installation_video_44.mp4","installation_video_45.mp4","installation_video_46.mp4","installation_video_47.mp4","installation_video_48.mp4","installation_video_49.mp4","installation_video_5.mp4","installation_video_50.mp4","installation_video_51.mp4","installation_video_52.mp4","installation_video_53.mp4","installation_video_54.mp4","installation_video_55.mp4","installation_video_56.mp4","installation_video_57.mp4","installation_video_58.mp4","installation_video_59.mp4","installation_video_6.mp4","installation_video_60.mp4","installation_video_61.mp4","installation_video_62.mp4","installation_video_63.mp4","installation_video_64.mp4","installation_video_65.mp4","installation_video_66.mp4","installation_video_67.mp4","installation_video_68.mp4","installation_video_69.mp4","installation_video_7.mp4","installation_video_70.mp4","installation_video_71.mp4","installation_video_72.mp4","installation_video_73.mp4","installation_video_74.mp4","installation_video_75.mp4","installation_video_76.mp4","installation_video_77.mp4","installation_video_78.mp4","installation_video_79.mp4","installation_video_8.mp4","installation_video_80.mp4","installation_video_81.mp4","installation_video_82.mp4","installation_video_83.mp4","installation_video_84.mp4","installation_video_85.mp4","installation_video_86.mp4","installation_video_87.mp4","installation_video_88.mp4","installation_video_89.mp4","installation_video_9.mp4","installation_video_90.mp4","installation_video_91.mp4","installation_video_92.mp4","installation_video_93.mp4","installation_video_94.mp4","installation_video_95.mp4","installation_video_96.mp4","installation_video_97.mp4","installation_video_98.mp4","installation_video_99.mp4","installation_video_189.mp4"];

    private layerConfig:LayerConfig[] = [
        {
            radius: 0.9,
            velocity: 3,
        },
        {
            radius: 1,
            velocity: -1
        },
        {
            radius: 1.1,
            velocity: 1
        },
        {
            radius: 1.2,
            velocity: -2
        },
        {
            radius: 1.3,
            velocity: -0.5
        }
    ];

    constructor(textureLoader:THREE.TextureLoader,
                d:GetExperienceResponse,
                bgDims:CameraView) {
        super();

        Main.mobile = false; //force not mobile on touch

        this.textureLoader = textureLoader;
        this.backgroundDims = bgDims;

        this.playOverlay = new PlayOverlay($("#container"), {}, this);

        this.raycaster = new THREE.Raycaster();

        this.texAtlas = new TextureAtlas(
            12,
            $("#atlasRenderer")
        );  

        this.seaRenderer = new LineTextureRenderer(
            'Hoefler Text SC',
            36,
            this.texAtlas
        );

        //title sequence
        this.titleSequence = new InstallationTitleSequence(
            this.seaRenderer,
            new TitleGenerator(
                d.template_sequence,
                [d.a, d.b, d.c],
                d.title
            )
        );
        this.titleSequence.translateZ(-150);
        this.titleSequence.scale.set(0.8, 0.8, 0.8);
        this.titleSequence.translateY(36);
        this.add(this.titleSequence);

        //genre sequence
        this.genreSequence = new InstallationGenreSequence(
            this.seaRenderer,
            new GenreGenerator(
                d.genres,
                Math.floor(d.film_length / 60)
            )
        );
        this.genreSequence.translateZ(-100);
        this.genreSequence.scale.set(0.25, 0.25, 0.25);
        this.genreSequence.translateY(10);
        this.add(this.genreSequence);
        this.genreSequence.dispatchEvent({type: SeancesIntroScene.TITLE_SWAP});

        //background
        this.videoBackground = new InstallationVideoBackground(this.backgroundDims.height, this.backgroundPool);
        this.videoBackground.translateZ(-1000);
        this.add(this.videoBackground);

        //event listeners 
        this.addEventListener(NickelScene.TICK_EVENT, e => {
            this.glitchPass.uniforms.fGlobalTime.value += 0.005;

            this.particleGroup.tick(e.message.dt);
        });

        let canvas = Stage.RENDERER.domElement;
        canvas.addEventListener('touchstart', e => this.touchStart(e), false);
        canvas.addEventListener('touchmove', e => this.touchMove(e), false);
        canvas.addEventListener('touchend', e => this.touchEnd(e), false);
        this.addEventListener('remove', () => clearTimeout(this.intensityTimeout));

        EventBus.addEventListener(PhotoCard.REMOVE_CARD, card => this.removeCard(card), this);
        EventBus.addEventListener(PhotoCard.COUNTDOWN_COMPLETE, (card => this.removeFromTouchedCards(card)), this);

        //init
        this.createCardPositionVectors();
        this.addInitialCards();
        this.ambientGlitchingTimer();
        this.initParticles();
        
    }

    public resolveTitle(){

        MultiTouchInterfaceScene.RESOLVING = true; 

        //make sure the title sequence shifts properly
        this.titleSequence.shift(true);
        TweenMax.delayedCall(3, ()=>{
            this.titleSequence.shift(true);
        });

        TweenMax.to(this.titleSequence.position, 25, {
            y:10,
            ease:Quad.easeOut
        });

        TweenMax.to(this.genreSequence.position, 25, {
            y:0,
            ease:Quad.easeOut,
            onComplete:()=>{
                this.playOverlay.showMe();    
            }
        });
    }

    private initParticles(){

        this.particleGroup = new SPE.Group({
            texture: {
                value: this.textureLoader.load('/img/smokeparticle.png')
            },
            blending: THREE.NormalBlending,
            maxParticleCount: MultiTouchInterfaceScene.EMITTER_PARTICLES * MultiTouchInterfaceScene.MAX_TOUCHES,
            hasPerspective: true
        });

        for (let emitters = 0; emitters < MultiTouchInterfaceScene.MAX_TOUCHES; emitters++) {
            const emitter = new SPE.Emitter({
                type: SPE.distributions.BOX,
                maxAge: {value: 1},
                size: {value: 50},
                particleCount: MultiTouchInterfaceScene.EMITTER_PARTICLES,
                opacity: {value: [0.2, 0.1, 0.08, 0]},

                rotation: {
                    axis: new THREE.Vector3(0, 0, 1),
                    static: true,
                    angle: 1
                },
                color: {
                    value: [
                        new THREE.Color().setHSL(0.61, 1, 0.8),
                        new THREE.Color().setHSL(0.38, 1, 0.8),
                        new THREE.Color().setHSL(0.38, 1, 0.8)
                    ]
                },
            });
            this.particleGroup.addEmitter(emitter);
            emitter.disable();

            this.particleEmitter[emitters.toString()] = emitter;
        }

        this.particleGroup.mesh.position.setZ(-1);
        this.particleGroup.mesh.renderOrder = RenderOrder.ParticleTrails;
        this.add(this.particleGroup.mesh);
    }

    private createCardPositionVectors() {

        const itemWidth = 30;
        const dims = Utils.calcCameraView(this.cardZPos);

        const center = new THREE.Vector3(0, 0, 0);

        Stage.CAMERA.updateMatrix();
        Stage.CAMERA.updateMatrixWorld(false);
        Stage.CAMERA.matrixWorldInverse.getInverse(Stage.CAMERA.matrixWorld);

        this.frustum = new THREE.Frustum();
        let matrix = new THREE.Matrix4().multiplyMatrices(Stage.CAMERA.projectionMatrix, Stage.CAMERA.matrixWorldInverse);

        this.frustum.setFromMatrix(matrix);

        for (var i = 0; i < this.layerConfig.length; i++) {

            let config = this.layerConfig[i];
            let radius = dims.width / 2 * config.radius;
            let circ = 2 * Math.PI * radius;
            let items = Math.floor(circ / itemWidth);
            let offset = (i % 2) ? 0 : 0.3; //makes it more "brick" like
            let pos = new THREE.Vector3(0, (dims.height / 2) - 1, 0);
            let layer = new CardLayer(config.velocity, pos);
            this.cardLayers.push(layer);
            this.add(layer);

            for (var j = 0; j < items; j++) {

                let placement = j + offset;
                let x = center.x + radius * Math.cos(2 * Math.PI * placement / items);
                let y = center.y + radius * Math.sin(2 * Math.PI * placement / items);
                let point = new THREE.Vector3(x, y, this.cardZPos);


                let rotation = Math.atan2(point.y - center.y, point.x - center.x) + 1.5708;
                let pos:CardPos = {
                    'layer': i,
                    'position': point,
                    'rotation': rotation
                };

                this.cardPositions.push(pos);
            }
        }
    }

    private touchStart(evt:TouchEvent) {

        evt.preventDefault();

        this.setTouchPositions(evt.touches);

        for (let i in evt.changedTouches) {

            let touch = evt.changedTouches[i];
            let id = touch.identifier;
            let pos = this.touchPositions[touch.identifier];

            if(pos){

                this.raycaster.setFromCamera(pos, Stage.CAMERA);

                let intersects = this.raycaster.intersectObjects(this.cards, true)[0];

                if (intersects && intersects.object.parent) {
                    let photoCard:any = intersects.object.parent;

                    if (photoCard && photoCard.interactive && !photoCard.countdownRunning && photoCard instanceof PhotoCard || photoCard instanceof VideoCard) {

                        photoCard.touchStarted(pos, id);
                        this.touchedCards[id] = photoCard;
                        this.particleEmitter[id].enable();
                    }
                }
            }
        }

        this.updateParticleTrails();
        this.checkGlitch();
    }

    private checkGlitch() {

        if (this.activeCards > 0) {
            this.intensity = 'slight';
        } else if (this.activeCards >= 3) {
            this.intensity = 'lots';
        } else if (this.activeCards >= 5) {
            this.intensity = 'crazy';
        } else if (this.activeCards >= 8) {
            this.intensity = 'frenetic';
        } else {
            this.intensity = 'none';
        }
    }

    private touchMove(evt:TouchEvent) {

        this.setTouchPositions(evt.touches);

        for(var i =0; i<this.touchedCards.length; i++){

            let card = this.touchedCards[i];
            if(card){
                card.touchMove(this.touchPositions[i], evt);
            }
        }

        this.updateParticleTrails();
    }

    public removeFromTouchedCards(card:PhotoCard){

        this.particleEmitter[card.touchIndex].disable();
        delete this.touchedCards[card.touchIndex];
    }

    private updateParticleTrails():void {

        this.activeCards = 0; //TODO, find a better place to do this count

        for(var i = 0; i<this.touchedCards.length; i++){

            let card = this.touchedCards[i];
            if(card){

                this.activeCards++;

                const bounds = card.imageMesh.geometry.boundingBox.clone().applyMatrix4(card.imageMesh.matrix);

                const width = bounds.max.x - bounds.min.x;
                const height = bounds.max.y - bounds.min.y;
                const angle = -card.rotation.z;

                const matrix = new THREE.Matrix4().makeRotationAxis(
                    this.particleEmitter[i].rotation.axis,
                    angle
                );

                const newPosition = card.position.clone();
                newPosition.applyMatrix4(matrix);

                this.particleEmitter[i].position.spread =
                    this.particleEmitter[i].position.spread.set(width, height, 0);

                this.particleEmitter[i].position.value.set(
                    newPosition.x,
                    newPosition.y,
                    this.cardZPos + 1
                );

                this.particleEmitter[i].rotation.angle = angle; 
            }
        }
    }


    private setTouchPositions(touches:TouchList) {

        if(touches){
            for (var i = 0; i < touches.length; ++i) {
                let id = touches[i].identifier;
                this.touches[id] = touches[i];
                this.touchPositions[id] = this.getTouchPos(touches[i]);
            }
        }
    }

    private removeCard(photoCard:PhotoCard):void {
        const index = _.findIndex(this.cards, card => card.id === photoCard.id);

        if (index !== -1) {
            this.cards.splice(index, 1);
            let pos = photoCard.cardPos;
            this.remove(photoCard);
            this.cardPositions.push(pos);
            this.cardPool.push(photoCard);
        }

        if(!MultiTouchInterfaceScene.RESOLVING){
            this.useCard();
        }
    }

    private touchEnd(evt:TouchEvent) {

        evt.preventDefault();

        //loop through the changed touches, and end them
        for (var i = 0; i<evt.changedTouches.length; i++) {
            
            let touch = evt.changedTouches[i];
            let id = touch.identifier;
            let card = this.touchedCards[id];

            if(card){
                card.touchEnd();   
            }

            delete this.touches[id];
            delete this.touchPositions[id];
            delete this.touchedCards[id];

            this.particleEmitter[id].disable();
        }

        this.checkGlitch();
    }

    private getTouchPos(t:Touch):THREE.Vector3 {
        let x = ( t.clientX / window.innerWidth ) * 2 - 1;
        let y = -( t.clientY / window.innerHeight ) * 2 + 1;
        return new THREE.Vector3(x, y, 0.5);
    }

    public addInitialCards() {

        let items = this.cardPositions.length * MultiTouchInterfaceScene.FILL_RATE;
        this.cardImagePool = <string[]>_.shuffle(this.cardImagePool);
        this.cardVideoPool = <string[]>_.shuffle(this.cardVideoPool);

        //create the pool
        for (var i = 0; i < items*1.1; i++) {
            let index = i % (this.cardImagePool.length-1);
            this.addCard(index);
        }

        //use the cards
        for (var j = 0; j < items   ; j++) {
            this.useCard();
        }
    }

    public useCard() {

        let index = _.random(0, this.cardPool.length - 1);
        let card = this.cardPool[index];
        let pos = this.getPosition();
        this.cardPool.splice(index, 1);
        this.cards.push(card);
        this.cardLayers[pos.layer].add(card);
        card.setPosition(pos);
        card.show();
    }

    public addCard(photoIndex:number) {

        var card, src;
        if(Math.random() >= MultiTouchInterfaceScene.VIDEO_RATE){
            src = '/img/installation_images/' + this.cardImagePool[photoIndex];
            card = new PhotoCard(this.textureLoader, src);
        }else{
            src = '/vid/installation/' + this.cardVideoPool[photoIndex];
            card = new VideoCard(this.textureLoader, src);
        }
        
        this.cardPool.push(card);
    }

    private getPosition():CardPos {

        let index = _.random(0, this.cardPositions.length - 1);
        let item = this.cardPositions[index];
        let pos = item.position;

        if(this.isOnScreen(pos)){
            this.cardPositions.splice(index, 1);
            return item;
        }else{
            return this.getPosition();
        }
    }

    private isOnScreen(position){

        return true;
    }

    public getPostProcessingPasses() {
        this.glitchPass = new ShaderPass(new RGBGlitchShader());
        this.glitchPass.uniforms.tDiffuseNoise.value = this.textureLoader.load('/img/tex16.png');
        this.glitchPass.uniforms.tDiffuseNoise.value.wrapS = this.glitchPass.uniforms.tDiffuseNoise.value.wrapT = THREE.RepeatWrapping;

        // this.artifactPass = new THREE.ShaderPass(new MPEGArtifactShader());
        // this.artifactPass.uniforms.tDiffuseNoise.value = this.textureLoader.load('/img/tex16.png');
        // this.artifactPass.uniforms.tDiffuseNoise.value.wrapS = this.artifactPass.uniforms.tDiffuseNoise.value.wrapT = THREE.RepeatWrapping;

        return [this.glitchPass];
    }

    public set intensity(glitch:GlitchIntensity) {
        switch (glitch) {
            case 'none':
                this.glitchPass.uniforms.fSpeed.value = 0.2;
                this.glitchPass.uniforms.fAmplitude.value = 0;
                if (this.titleSequence) this.titleSequence.children.forEach(i => {
                    if (i instanceof Word)
                        i.material.uniforms.fDistortionIntensity.value = 0.0
                });
                return;
            case 'slight':
                this.glitchPass.uniforms.fSpeed.value = 0.2;
                this.glitchPass.uniforms.fAmplitude.value = 0.04;
                if (this.titleSequence) this.titleSequence.children.forEach(i => {
                    if (i instanceof Word)
                        i.material.uniforms.fDistortionIntensity.value = 0.00025
                });
                return;
            case 'lots':
                this.glitchPass.uniforms.fSpeed.value = 0.4;
                this.glitchPass.uniforms.fAmplitude.value = 0.08;
                if (this.titleSequence) this.titleSequence.children.forEach(i => {
                    if (i instanceof Word)
                        i.material.uniforms.fDistortionIntensity.value = 0.000375
                });
                return;
            case 'crazy':
                this.glitchPass.uniforms.fSpeed.value = 0.6;
                this.glitchPass.uniforms.fAmplitude.value = 0.12;
                if (this.titleSequence) this.titleSequence.children.forEach(i => {
                    if (i instanceof Word)
                        i.material.uniforms.fDistortionIntensity.value = 0.00050
                });
                return;
            case 'frenetic':
                this.glitchPass.uniforms.fSpeed.value = 0.8;
                this.glitchPass.uniforms.fAmplitude.value = 0.16;
                if (this.titleSequence) this.titleSequence.children.forEach(i => {
                    if (i instanceof Word)
                        i.material.uniforms.fDistortionIntensity.value = 0.000625
                });
                return;
        }
    }

    public get intensity():GlitchIntensity {
        switch (this.glitchPass.uniforms.fAmplitude.value) {
            case 0:
                return 'none';
            case 0.04:
                return 'slight';
            case 0.08:
                return 'lots';
            case 0.12:
                return 'crazy';
            case 0.16:
                return 'frenetic';
        }
    }

    private ambientGlitchingTimer():void {
        if (this.glitchPass && this.intensity === 'none') {
            this.intensityTween = TweenMax.delayedCall(
                Math.random() * 9 + 1,
                () => {
                    if (this.glitchPass && this.intensity === 'none')
                        this.intensity = 'slight';
                    this.ambientGlitchingTimer();
                });
        } else if (this.glitchPass && this.intensity === 'slight') {
            this.intensityTween = TweenMax.delayedCall(
                (Math.sin(2 * Math.PI * Math.random()) / 5 + 1),
                () => {
                    if (this.glitchPass)
                        this.intensity = 'none';
                    this.ambientGlitchingTimer();
                });
        } else {
            this.intensityTween = TweenMax.delayedCall(1, () => this.ambientGlitchingTimer());
        }
        return;
    }

}

interface CardPos {
    layer:number;
    position:THREE.Vector3;
    rotation:number;
}

interface LayerConfig {
    radius:number;
    velocity:number;
}

